import { getStore } from "../store/store";
import { mutatorAction } from "satcheljs";
import type MailFolderNodeViewState from "../store/schema/MailFolderNodeViewState";

/*
 * Sets folder node view state
 * @param folderId the folder whose view state we are updating
 * @param folderViewState the view state to set
 */
const setFolderViewStateMutator: typeof setFolderViewStateInner = mutatorAction("setFolderViewState", setFolderViewStateInner);
export default setFolderViewStateMutator;

export function setFolderViewStateInner(folderId: string, folderViewState: MailFolderNodeViewState): void {
    getStore().folderNodeViewStates.set(folderId, folderViewState);
}
